import { useQuery } from '@fv/client-core'
import type { ShipperUserContext } from '@fv/models'

import { shipperFetch } from '@/utils/shipperFetch'

export type AppUserContext = { user: ShipperUserContext }

const fetchAppContext = async () => shipperFetch<AppUserContext>(`/context`)

export const appContextQueryKey = ['app-context']
export function useAppContext(enabled = true) {
  return useQuery(appContextQueryKey, fetchAppContext, {
    enabled,

    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  })
}

export const useAccountId = () => {
  return useAppContext().data?.user?.accountIds?.[0] ?? undefined
}

export const useCurrentUser = () => {
  const context = useAppContext()
  if (!context.data.user) {
    throw new Error('User data not present')
  }
  return context.data.user
}

export const useRestrictNewLtlCarriers = () => {
  return useCurrentUser().restrictNewLtlCarriers
}

export const useHasIdp = () => {
  const user = useCurrentUser()
  return user.hasIdp
}
